import {
  objectivesCollection,
  keyResultsCollection,
  auth,
  db,
} from "../firebase.config";

const state = {
  objectives: [],
  gettingObjectives: false,
  keyResults: [],
  gettingKeyResults: false,
  updates: [],
  gettingUpdates: false,
};

const mutations = {
  SET_OBJECTIVES(state, objectives) {
    state.objectives = objectives;
  },
  ADD_TO_OBJECTIVES(state, objective) {
    state.objectives.push(objective);
  },
  SET_GETTING_OBJECTIVES(state, boolean) {
    state.gettingObjectives = boolean;
  },
  SET_KEY_RESULTS(state, keyResults) {
    state.keyResults = keyResults;
  },
  SET_GETTING_KEY_RESULTS(state, boolean) {
    state.gettingKeyResults = boolean;
  },
  ADD_TO_KEY_RESULTS(state, keyResult) {
    state.keyResults.push(keyResult);
  },
  SET_UPDATES(state, updates) {
    state.updates = updates;
  },
  SET_GETTING_UPDATES(state, boolean) {
    state.gettingUpdates = boolean;
  },
};

const actions = {
  createObjective({ rootState, dispatch, commit }, objective) {
    const objectiveDoc = {
      title: objective,
      companyId: rootState.users.profile.companyId,
      createdBy: auth.currentUser.uid,
    };
    objectivesCollection
      .add(objectiveDoc)
      .then(() => {
        commit("ADD_TO_OBJECTIVES", objectiveDoc);
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t create your objective",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
      });
    heap.track("createObjective");
  },
  createObjectivesFromArray({ dispatch }, payload) {
    payload.objectives.forEach((objective) =>
      dispatch("createObjective", objective)
    );
    heap.track("createObjectives");
  },
  getObjectives({ dispatch, commit }, companyId) {
    commit("SET_GETTING_OBJECTIVES", true);
    return objectivesCollection
      .where("companyId", "==", companyId)
      .get()
      .then((docs) => {
        const objectives = [];
        docs.forEach((doc) => {
          var objective = doc.data();
          objective.id = doc.id;
          objectives.push(objective);
        });
        commit("SET_OBJECTIVES", objectives);
        commit("SET_GETTING_OBJECTIVES", false);
        return docs;
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t get your objectives",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        commit("SET_GETTING_OBJECTIVES", false);
      });
  },
  getKeyResults({ dispatch, commit }, companyId) {
    commit("SET_GETTING_KEY_RESULTS", true);
    return keyResultsCollection
      .where("companyId", "==", companyId)
      .get()
      .then((docs) => {
        const keyResults = [];
        docs.forEach((doc) => {
          var keyResult = doc.data();
          keyResult.id = doc.id;

          keyResults.push(keyResult);
        });
        commit("SET_KEY_RESULTS", keyResults);
        commit("SET_GETTING_KEY_RESULTS", false);
        return docs;
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t get your Key Results",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        commit("SET_GETTING_KEY_RESULTS", false);
      });
  },
  getUpdates({ dispatch, commit }, companyId) {
    commit("SET_GETTING_UPDATES", true);
    return db
      .collection("updates")
      .where("companyId", "==", companyId)
      .orderBy("date", "desc")
      .get()
      .then((docs) => {
        const updates = [];
        docs.forEach((doc) => {
          var update = doc.data();
          update.id = doc.id;
          updates.push(update);
        });
        commit("SET_UPDATES", updates);
        commit("SET_GETTING_UPDATES", false);
        return docs;
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t get your updates",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        commit("SET_GETTING_UPDATES", false);
      });
  },
  getGoals({ dispatch }, companyId) {
    return Promise.all([
      dispatch("getObjectives", companyId),
      dispatch("getKeyResults", companyId),
      dispatch("getUpdates", companyId),
    ]);
  },
};

const getters = {
  objectives: (state) => state.objectives,
  gettingObjectives: (state) => state.gettingObjectives,
  keyResults: (state) => state.keyResults,
  gettingKeyResults: (state) => state.gettingKeyResults,
  updates: (state) => state.updates,
  gettingUpdates: (state) => state.gettingUpdates,
};

const goalsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default goalsModule;
